import React, { useEffect, useState } from 'react';
import { Select } from 'antd';
import { LinkComponent } from '../../LinkComponent';
import { getCardV2, getCardsV2 } from '../../../middleware';
import { FieldInfo } from '../../Forms';
import Styles from './m_styles.less';

export const CardsSearch: React.FC<{
    card: any;
    setSelectedCard: (card: any) => void;
    setHierarchy: (hierarchy: any) => void;
}> = ({ card, setSelectedCard, setHierarchy }) => {
    const [searchQuery, setSearchQuery] = useState('');
    const [cards, setCards] = useState<any[]>([]);

    const fetchCardById = async (cardId: string) => {
        const response = await getCardV2(cardId);
        setSelectedCard(response.data);
    };

    const searchForCards = async (query: string) => {
        const response = await getCardsV2(query);
        const activeCards = response.data.filter((card: any) => !card.attributes.deleted_at);
        setCards(activeCards);
    };

    const clearSearch = () => {
        const newUrl = `${window.location.pathname}`;
        window.history.pushState({}, '', newUrl);
        setSearchQuery('');
        searchForCards('');
        setCards([]);
        setSelectedCard(null);
        setHierarchy(null);
    };

    const onSelect = (card: any) => {
        const foundCard = cards.find((c) => c.id === card.split('-')[0]);

        setSearchQuery('');
        setSelectedCard(foundCard);
        const newUrl = `${window.location.pathname}?cardId=${foundCard.id}`;
        window.history.pushState({}, '', newUrl);
    };

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const cardIdFromUrl = urlParams.get('cardId');

        if (cardIdFromUrl && !card) {
            fetchCardById(cardIdFromUrl);
        }
    }, []);

    useEffect(() => {
        searchForCards(searchQuery);
    }, [searchQuery]);

    const options = cards.map((card) => {
        return {
            value: `${card.id}-${card.attributes.name}-${card.attributes.pritentd_id}-${card.attributes.eid}`,
            label: (
                <div>
                    ID: {card.id} Name: {card.attributes.name} Pritentd ID: {card.attributes.pritentd_id} EID:{' '}
                    {card.attributes.eid}
                </div>
            ),
        };
    });

    return (
        <div>
            <div className={Styles.searchContainer}>
                <Select
                    options={options}
                    className={Styles.searchInput}
                    showSearch={true}
                    searchValue={searchQuery}
                    onSearch={(value: string) => setSearchQuery(value)}
                    onSelect={onSelect}
                    placeholder={'Search cards..'}
                    allowClear={true}
                    onClear={clearSearch}
                />
            </div>
            {card && (
                <div className={Styles.currentCardBanner}>
                    <h3 className={Styles.heading}>Chosen card: </h3>
                    <FieldInfo title={'ID'}>{card.id}</FieldInfo>
                    <FieldInfo title={'Card Name'}>
                        {card.attributes.name ? (
                            <LinkComponent currentListComponent={'CardList'} id={card.id} name={card.attributes.name} />
                        ) : (
                            'N/A'
                        )}
                    </FieldInfo>
                    <FieldInfo title={'Pritentd Id'}>{card?.attributes.pritentd_id || 'N/A'}</FieldInfo>
                    <FieldInfo title={'EID'}>{card?.attributes.eid || 'N/A'}</FieldInfo>
                </div>
            )}
        </div>
    );
};
